import React from 'react';
import styled, { keyframes } from 'styled-components';

const loadingFade = keyframes`
   from {
      opacity: 1;
   }

   50% {
      opacity: 0.25;
   }

   to {
      opacity: 1;
   }
`;

const ButtonStyles = styled.button`
   user-select: none;
   text-align: center;
   font-size: 1em;

   font-family: var(--content-font);
   position: relative;
   z-index: 1;
   border-radius: 5px;
   padding: 0.75em 1em;
   border: 2px solid;
   font-weight: bold;
   cursor: pointer;
   text-decoration: none;
   display: inline-block;
   color: var(--text-color);
   border-color: var(--text-color);
   background-color: transparent;
   transition: background-color 0.25s ease, color 0.25s ease,
      border-color 0.25s ease;

   :hover:not(:disabled, .disabled),
   :focus-visible:not(:disabled, .disabled),
   :active:not(:disabled, .disabled) {
      background-color: var(--hover-color);
      color: var(--hover-text-color);
      border-color: var(--brand-darker-orange);
      outline: none;
   }

   :disabled,
   &.disabled {
      transition: none;
      pointer-events: none;
      cursor: default;
      opacity: 0.3;
   }

   @media (prefers-color-scheme: dark) {
      :hover:not(:disabled, .disabled),
      :focus-visible:not(:disabled, .disabled),
      :active:not(:disabled, .disabled) {
         outline: none;
         background-color: transparent;
         color: var(--brand-orange);
         border-color: var(--brand-orange);
      }
   }

   &.button-dismiss {
      color: var(--brand-green);
      border: none;
      min-width: unset;

      &:hover:not(:disabled),
      &:focus-visible:not(:disabled),
      &:active:not(:disabled) {
         background-color: transparent;
         color: var(--hover-color);
      }
   }

   &.button-link {
      color: var(--text-color);
      border: none;
      min-width: unset;
      text-decoration: underline;
      padding: 0;
      display: inline-block;

      &:hover:not(:disabled),
      &:focus-visible:not(:disabled),
      &:active:not(:disabled) {
         background-color: transparent;
         color: var(--hover-color);
      }
   }

   &.button-cta {
      background-color: var(--brand-orange);
      border-color: var(--brand-darker-orange);
      color: var(--hover-text-color);

      text-shadow: 1px 1px 1px black, 1px 1px 1px black;

      :hover:not(:disabled, .disabled),
      :focus-visible:not(:disabled, .disabled),
      :active:not(:disabled, .disabled) {
         background-color: var(--brand-light-orange);
      }

      :disabled,
      &.disabled {
         opacity: 0.5;
      }
   }

   @media (prefers-color-scheme: dark) {
      &.button-cta {
         color: var(--brand-light-orange);
         border-color: var(--brand-light-orange);
         background-color: transparent;
         text-shadow: none;

         :hover:not(:disabled),
         :focus-visible:not(:disabled),
         :active:not(:disabled) {
            background-color: transparent;
         }
      }
   }

   &.button-loading span {
      animation: ${loadingFade} 2.5s ease-in-out infinite;
   }

   &.button-icon {
      display: inline-flex;

      > span {
         display: inline-flex;
         align-items: center;
      }
   }

   &.icon-with-text {
      svg {
         margin-right: 0.75em;
      }
   }
`;

const Button = ({ children, ...props }) => (
   <ButtonStyles {...props}>
      <span>{children}</span>
   </ButtonStyles>
);

export { Button };
